import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import { Paginator } from 'primereact/paginator';

function App() {
    const [Data, setData] = useState(0);
     const [searchQuery, setSearchQuery] = useState('');
        const [filteredData, setFilteredData] = useState(Data?.data);
        const [first, setFirst] = useState(0); 
        const [rows, setRows] = useState(10); 


        const fetchData = async (offset) => {
          try {
            const sendData = {next: offset}
             const  response = await axios.get('https://api.trucoo.in/payment/allexpense/',{params: sendData});
              setData(response.data);
           console.log(response.data);
          } catch (error) {
            // Handle error if needed
          }
        };
      
         useEffect(() => {
               fetchData(0);
             }, []); 
       
       
       
             const handleSearchInputChange = (event) => {
          
        
               const query = event.target.value;
               setSearchQuery(query);
             
               // Filter datas.data based on search query
               const filtered = Data?.data?.filter(expense =>
                 
                expense.category.toLowerCase().includes(query.toLowerCase()) ||
                expense.date.toLowerCase().includes(query.toLowerCase())
               );
               setFilteredData(filtered);
             
             
             };
       
             const onPageChange = (event) => {
               fetchData(event.first);
         }; 

      

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
                <div class="col-12">
            <div class="box">
				<div class="box-header with-border">
                <a href="/addexpense" class="waves-effect waves-light btn mb-5 bg-gradient-info" style={{float: "right"}}>Add Expenses</a>
                   <h4 class="box-title">Expenses</h4>
				</div>
				
				<div class="box-body">
					<div class="table-responsive">
                    {/* <div class="dt-buttons btn-group">    
                    <button class="btn btn-secondary buttons-copy buttons-html5" tabindex="0" aria-controls="example"><span>Copy</span></button> <button class="btn btn-secondary buttons-csv buttons-html5" tabindex="0" aria-controls="example"><span>CSV</span></button> <button class="btn btn-secondary buttons-excel buttons-html5" tabindex="0" aria-controls="example"><span>Excel</span></button> <button class="btn btn-secondary buttons-pdf buttons-html5" tabindex="0" aria-controls="example"><span>PDF</span></button> <button class="btn btn-secondary buttons-print" tabindex="0" aria-controls="example"><span>Print</span></button> </div> */}
                    <div id="example_filter" class="dataTables_filter"><label><input type="search" class="form-control form-control-sm mb-5"  placeholder="Search By category or date" value={searchQuery}
                    onChange={handleSearchInputChange}  style={{left:'10px'}} aria-controls="example"/></label></div>
					  <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                    
                        <thead>
							<tr class="text-dark">
								<th>SI.NO</th>
								<th>category</th>
								<th>Date</th>
								<th>Amount</th>
								<th>Description</th>
							</tr>
						</thead>
						<tbody>
            {searchQuery && filteredData.length > 0 ? (
            <>  {filteredData.map((expense, index) => ( 
              <tr>
              <td>{index + 1}</td>
              <td >{expense.category}</td>
              <td >{expense.date}</td>
              <td >{expense.amount}</td>
              <td >{expense.description}</td>
               

</tr>
            ))}
            </>
            
            ) : searchQuery && filteredData.length === 0 ? (
              <tr >
                           <td>No products found </td>
                         </tr>
           ) : (<>
                            {Data?.data?.map((expense, index) => (
							<tr>
                                <td>{index + 1}</td>
                                <td >{expense.category}</td>
                                <td >{expense.date}</td>
                                <td >{expense.amount}</td>
                                <td >{expense.description}</td>
                                 
								
							</tr>
                             ))}
                   </>)}
                                          
               </tbody>	
              </table>
               <Paginator className="custom-paginator" first={first} rows={rows} totalRecords={Data.ReadCount}  onPageChange={onPageChange} />
                                         
                    
					</div>              
				</div>
				
			  </div>
              </div>
			</section>


       

		</div>
	</div>
</>
);
}

export default App;